import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import Home from './Home';
import Suggests from './Suggests';
import Contact from './Contact';
import Login from './Login';
import Invites from './Invites';
import AddInvites from './AddInvites';
import Tables from './Tables';
import Expenses from './Expenses';
import Buy from './Buy';
import InvitationResponse from './InvitationResponse ';
import Info from './Info';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from './PrivacyPolicy';
import GeneralInvitation from './GeneralInvitation';

ReactGA.initialize("G-D8JD4T46K0");

function SiteRoutes() {
    const location = useLocation();
  
    useEffect(() => {
      window.scrollTo(0, 0);

      ReactGA.send({ hitType: "pageview", page: location.pathname });

    }, [location]);

  return (
    <>
    <Routes>
    <Route path='/' element={<Home/>}/>
    <Route path='/suggests' element={<Suggests/>}/>
    <Route path='/contact' element={<Contact/>}/>
    <Route path='/login' element={<Login/>}/>
    <Route path='/my-invites' element={<Invites/>}/>
    <Route path='/add-invites' element={<AddInvites/>}/>
    <Route path='/personal_info' element={<Info/>}/>
    <Route path='/tables' element={<Tables/>}/>
    <Route path='/expenses' element={<Expenses/>}/>
    <Route path='/buy' element={<Buy/>}/>
    <Route path="/invitation/confirm/:uuid" element={<InvitationResponse />} />
    <Route path='/useterms' element={<TermsOfUse />}/>
    <Route path='/privacy' element={<PrivacyPolicy />}/>
    <Route path="/invitation/general/:slug" element={<GeneralInvitation />} />
    </Routes>
    </>
  )
}

export default SiteRoutes;